
import { Component, Prop, Vue } from 'vue-property-decorator';
import { DepartmentInterface } from '@/services/Departments/Interfaces';
import DepartmentRepository from '@/services/Departments';

@Component({
  inject: [
    'departmentRepository',
  ],
})
export default class DeleteDepartmentDialog extends Vue {
  private readonly departmentRepository!: DepartmentRepository;

  @Prop() private readonly department!: DepartmentInterface;

  private visible: boolean = true;

  get message(): string {
    return `Are you sure you want to delete ${this.department.name}?`;
  }

  private async deleteDepartment(): Promise<void> {
    try {
      await this.departmentRepository.deleteDepartment(this.department._id);
      this.$successDialog.show(`Department ${this.department.name} has been deleted.`);
      this.$emit('deleted-department', this.department._id);
      this.destroyComponent();
    } catch (e) {
      this.$errorDialog.show(e.response.data.message);
      this.destroyComponent();
    }
  }

  private destroyComponent(): void {
    this.$emit('close');
  }
}
